"use client"

import { createContext, useContext, useCallback, ReactNode } from 'react'
import { useRouter, useSearchParams } from 'next/navigation'

type NavigationContextType = {
  currentView: string
  navigateTo: (view: string, params?: Record<string, string>) => void
  getParam: (key: string) => string | null
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined)

export function NavigationProvider({ children }: { children: ReactNode }) {
  const router = useRouter()
  const searchParams = useSearchParams()

  const currentView = searchParams.get('view') || 'dashboard'

  const navigateTo = useCallback((view: string, params: Record<string, string> = {}) => {
    const queryParams = new URLSearchParams({ view, ...params })
    router.push(`/?${queryParams.toString()}`)
  }, [router])

  const getParam = useCallback((key: string) => {
    return searchParams.get(key)
  }, [searchParams])

  return (
    <NavigationContext.Provider value={{ currentView, navigateTo, getParam }}>
      {children}
    </NavigationContext.Provider>
  )
}

export function useNavigation() {
  const context = useContext(NavigationContext)
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider')
  }
  return context
} 